module.exports = __webpack_public_path__ + "img/97.3.2f3117ff.png";